define('boxes/signup-detail',['jquery', 'module', 'boxes/helpers/signUpValidation', 'boxes/helpers/tooltip', 'boxes/helpers/message-popup', 'boxes/box', 'boxes/helpers/box-loading', 'all/comeon', 'all/pretty-links', 'boxes/helpers/signup-login', 'boxes/events/signUpEvent', 'boxes/events/landingEvent', 'all/player/security', 'boxes/helpers/middle-bar-helper', 'boxes/helpers/address-finder', 'boxes/helpers/signup-render', 'all/jquery/jquery.mustache'], function ($, module, signUpValidation, toolTip, messagePopup, box, boxLoading, comeon, prettyLinks, signupLogin, signUpEvent, landingEvent, security, middleBarHelper, addressFinder, signupRenderHelper) {
	'use strict';
	var ERROR_CLASS = 'has-error',
		VALID_CLASS = 'is-valid',
		HAS_AUTOFILL_CLASS = 'has-autofill',
		wrongPersonalNumber = false,
		PERSON_LOOKUP_PATH = '/PersonLookup/personalnumber/',
		DYNAMIC_ERROR_MESSAGE_DATA_ATTRIBUTE = 'content-dynamic-error',
		WRONG_NUMBER_AUTOFILL_ERROR = 'wrong-number',

		configuration = module.config(),

		$autoFillInput,
		isSubmitClicked = false,
		isValidPhone = false,
		isValidPhoneChecked = false,
		ENTER_EVENT = 13,
		countryIsoCode,
		siteId;

	function fillUsernameEmailFromFirstStep(signUpDetail, data) {
		var username = data.PARAM_USR_NAME,
			email = data.PARAM_EMAIL,
			password = data.PARAM_PASSWORD,
			bonusCode = data.PARAM_BONUS_CODE,
			firstName = data.PARAM_FIRST_NAME,
			surname = data.PARAM_SURNAME;

		signUpDetail.$box.find('dd[title=username]').text(username);
		signUpDetail.$box.find('dd[title=email]').text(email);

		signUpDetail.$box.find('input[name=PARAM_FIRST_NAME]').val(firstName);
		signUpDetail.$box.find('input[name=PARAM_SURNAME]').val(surname);
		signUpDetail.$box.find('input[name=PARAM_USR_NAME]').val(username);
		signUpDetail.$box.find('input[name=PARAM_EMAIL]').val(email);
		signUpDetail.$box.find('input[name=PARAM_PASSWORD]').val(password);
		signUpDetail.$box.find('input[name=repeatPassword]').val(password);
		signUpDetail.$box.find('input[name=PARAM_BONUS_CODE]').val(bonusCode);

		for (var i = 0, x = password.length; i < x; i++) {
			password = password.replace(password.charAt(i), '*');
		}
		signUpDetail.$box.find('dd[title=password]').text(password);

	}

	function autoFillField(value, element) {
		var $element = $(element);
		$element.val(value);
		$element.parent().addClass(HAS_AUTOFILL_CLASS).removeClass(ERROR_CLASS);
	}

	function autoFillGender(signUpDetail, personalNumber) {
		var length = personalNumber.length,
			genderDigit,
			$genderElement = signUpDetail.$box.find('.gender');
		if(siteId===8){
			genderDigit = personalNumber.charAt(length - 2);
		}else if (countryIsoCode === 'se' || countryIsoCode === 'fi' || countryIsoCode === 'dk') {
			genderDigit = personalNumber.charAt(length - 2);
		} else if (countryIsoCode === 'no') {
			genderDigit = personalNumber.charAt(length - 3);
		}
		if ((genderDigit % 2) === 0) {
			autoClickFemale($genderElement);
		} else {
			autoClickMale($genderElement);
		}
	}

	function autoClickFemale($genderElement) {
		$genderElement.find('div:nth-child(2)').addClass('active');
		$genderElement.find('input[name=PARAM_GENDER_FEMALE]').val('female');
		$genderElement.find('div:nth-child(1)').removeClass('active').val('');
		$genderElement.find('input[name=PARAM_GENDER_MALE]').val('');
	}

	function autoClickMale($genderElement) {
		$genderElement.find('div:nth-child(2)').removeClass('active');
		$genderElement.find('input[name=PARAM_GENDER_FEMALE]').val('');
		$genderElement.find('div:nth-child(1)').addClass('active').val();
		$genderElement.find('input[name=PARAM_GENDER_MALE]').val('male');
	}

	function setupAutoFillClickLogic(signUpDetail) {
		signUpDetail.$box.find('#person-lookup-button').click(function (e) {
			e.preventDefault();
			var $personalNumberElement = signUpDetail.$box.find('input[name=personalnumber]'),
				$parentPersonalNumber = $personalNumberElement.parent(),
				personalNumber = $personalNumberElement.val();
			signUpValidation.hideGreenTick($autoFillInput);
			showLoadingGif($parentPersonalNumber);
			var requestPath;
			if(siteId===8){
				requestPath=PERSON_LOOKUP_PATH + "pl" + '/' + personalNumber
			}else{
				requestPath=PERSON_LOOKUP_PATH + countryIsoCode + '/' + personalNumber
			}
			$.post(requestPath)
				.done(function (person) {
					handleSuccessResponse(person, signUpDetail, personalNumber);
				}).fail(function (objResponse) {
				handleFailedResponse(objResponse, signUpDetail, $parentPersonalNumber);
			});
		});
	}


	function handleSuccessResponse(person, signUpDetail, personalNumber) {
		var $loadingImg = signUpDetail.$box.find('.autofill img');

		autoFillField(person.firstName, signUpDetail.$box.find('input[name=PARAM_FIRST_NAME]'));
		autoFillField(person.surname, signUpDetail.$box.find('input[name=PARAM_SURNAME]'));
		autoFillYearMonthDay(signUpDetail, personalNumber);
		autoFillField(person.address, signUpDetail.$box.find('input[name=PARAM_ADDRESS1]'));
		autoFillField(person.postalCode, signUpDetail.$box.find('input[name=PARAM_POST_CODE]'));
		autoFillField(person.city, signUpDetail.$box.find('input[name=PARAM_CITY]'));
		autoFillGender(signUpDetail, personalNumber);
		$loadingImg.hide();
		wrongPersonalNumber = false;
		$autoFillInput.parent().addClass(VALID_CLASS).removeClass(ERROR_CLASS);
		$autoFillInput.parent().removeData(DYNAMIC_ERROR_MESSAGE_DATA_ATTRIBUTE);
		signUpDetail.$box.find('.popover').hide();
		signUpValidation.showGreenTick($autoFillInput.parent());
	}

	function handleFailedResponse(objResponse, signUpDetail, $parentPersonalNumber) {
		hideLoadingGif($parentPersonalNumber);
		if (objResponse.status === 404) {
			var wrongError = $autoFillInput.parent().data(WRONG_NUMBER_AUTOFILL_ERROR);
			$autoFillInput.parent().data(DYNAMIC_ERROR_MESSAGE_DATA_ATTRIBUTE, wrongError);
			$autoFillInput.parent().addClass(ERROR_CLASS).removeClass(VALID_CLASS);
			wrongPersonalNumber = true;
			signUpValidation.hideGreenTick($autoFillInput);
			cleanAutoFillForm(signUpDetail);
			toolTip.showError($autoFillInput.parent());
		}
	}

	function autoFillYearMonthDay(signUpDetail, personalNumber) {
		var year, month, day, firstTwoDigitOfYear, secondTwoDigitOfYear,
			currentTime = new Date(),
			secondTwoDigitOfCurrentYear = currentTime.getFullYear().toString().substr(0, 2),
			$year = signUpDetail.$box.find('select[name=PARAM_YEAR]'),
			$month = signUpDetail.$box.find('select[name=PARAM_MONTH]'),
			$day = signUpDetail.$box.find('select[name=PARAM_DAY]');
		if(siteId===8){
			secondTwoDigitOfYear = personalNumber.substr(0, 2);
			var monthInt = parseInt(personalNumber.substr(2, 2).replace(/^0+/, '')) % 20;
			month = monthInt.toString();
			var monthRaw = parseInt(personalNumber.substr(2, 2).replace(/^0+/, ''));
			day = personalNumber.substr(4, 2).replace(/^0+/, '');
			if (parseInt(monthRaw, 10) <= 12 && parseInt(monthRaw, 10) >= 1) {
				firstTwoDigitOfYear = 19;
			} else if (parseInt(monthRaw, 10) <= 32 && parseInt(monthRaw, 10) >= 21) {
				firstTwoDigitOfYear = 20;
			} else if (parseInt(monthRaw, 10) <= 52 && parseInt(monthRaw, 10) >= 41) {
				firstTwoDigitOfYear = 21;
			} else if (parseInt(monthRaw, 10) <= 72 && parseInt(monthRaw, 10) >= 61) {
				firstTwoDigitOfYear = 22;
			} else if (parseInt(monthRaw, 10) <= 92 && parseInt(monthRaw, 10) >= 81) {
				firstTwoDigitOfYear = 18;
			} else {
				firstTwoDigitOfYear = 19;
			}

			year = Number(firstTwoDigitOfYear + secondTwoDigitOfYear);
		}else if (countryIsoCode === 'se') {
			//this is needed to fix the problem of people born after 1999 who enter their civic number in the auto fill
			//and then we build by default their birth year like 19+secondTwoDigitOfYear of the civic number
			secondTwoDigitOfYear = personalNumber.substr(0, 2);
			if (secondTwoDigitOfYear <= secondTwoDigitOfCurrentYear) {
				firstTwoDigitOfYear = 20;
			} else {
				firstTwoDigitOfYear = 19;
			}
			year = Number(firstTwoDigitOfYear + secondTwoDigitOfYear);
			month = personalNumber.substr(2, 2).replace(/^0+/, '');
			day = personalNumber.substr(4, 2).replace(/^0+/, '');
		} else {
			secondTwoDigitOfYear = personalNumber.substr(4, 2);
			if (secondTwoDigitOfYear <= secondTwoDigitOfCurrentYear) {
				firstTwoDigitOfYear = 20;
			} else {
				firstTwoDigitOfYear = 19;
			}
			year = Number(firstTwoDigitOfYear + secondTwoDigitOfYear);
			month = personalNumber.substr(2, 2).replace(/^0+/, '');
			day = personalNumber.substr(0, 2).replace(/^0+/, '');
		}
		autoFillField(year, $year);
		autoFillField(month, $month);
		autoFillField(day, $day);
	}

	function setupEditSummaryClickLogic(signUpDetail) {
		var switchToEditMode = function (e) {
			e.preventDefault();
			e.stopPropagation();
			signUpDetail.$box.find('.summary').hide();
			var $edit = signUpDetail.$box.find('.edit');
			$edit.show();
			$edit.find('input').each(function () {
				signUpValidation.showGreenTick($(this));
			});
		};
		signUpDetail.$box.find('.summary').find('a').click(switchToEditMode);
	}

	function getAjaxAutoFillPromise(signUpDetail) {
		var ajaxAutoFillPromise = comeon.promise.create();
		$.ajax({
			type: 'GET',
			url: PERSON_LOOKUP_PATH + countryIsoCode + '/1',
			statusCode: {
				405: function () {
					var $personalNumberContainer = signUpDetail.$box.find('.autofill'),
						$detailsHeader = signUpDetail.$box.find('.box.details').find('h1'),
						content = $detailsHeader.data('content-if-autofill');

					if (isPersonalLookupEnabled() === false  ||	$personalNumberContainer.attr('optimizely') === 'hide') {
						return;
					}
					// service available and eligible to be accessed, show autofill.
					$personalNumberContainer.show();
					$detailsHeader.text(content);
					signUpDetail.$box.find('.enter-manually').show();
				},
				404: function(){
					if(siteId==8) {
						var $personalNumberContainer = signUpDetail.$box.find('.autofill'),
							$detailsHeader = signUpDetail.$box.find('.box.details').find('h1'),
							content = $detailsHeader.data('content-if-autofill');

						if (isPersonalLookupEnabled() === false || $personalNumberContainer.attr('optimizely') === 'hide') {
							return;
						}
						// service available and eligible to be accessed, show autofill.
						$personalNumberContainer.show();
						$detailsHeader.text(content);
						signUpDetail.$box.find('.enter-manually').show();
					}
				}
			}
		}).always(function () {
			ajaxAutoFillPromise.resolve();
		});
		return ajaxAutoFillPromise.promise();
	}

	function getAjaxDetailDataPromise(signUpDetail) {
		var ajaxDetailDataPromise = comeon.promise.create();
		$.get('/pp?flow=SignUpJson', function (data) {
			signUpDetail.model.currencies = data.currencies;
			signUpDetail.model.countries = data.countries;
			signUpDetail.model.callingCode = data.callingCode;
			signUpDetail.model.states = data.states;
			signUpDetail.model.disableCountryCallingCode = data.disableCountryCallingCode;
			signUpDetail.model.danishGamblingRange = data.danishGamblingRange;
			ajaxDetailDataPromise.resolve();
		});
		return ajaxDetailDataPromise.promise();
	}

	function calculateLengthOfPersonalNumber(isOnlyNumeric) {
		if(siteId===8){
			return 11;
		}else if (countryIsoCode === 'se' || countryIsoCode === 'dk') {
			return isOnlyNumeric ? 10 : 11;
		}else {
			return isOnlyNumeric ? 11 : 12;
		}
	}

	function validateAutoFill(event) {

		function isAutoFillDirty() {
			return $autoFillInput.parent().hasClass('is-dirty');
		}

		function checkPesel(personalNumber) {
			function calculateCheckNumber(personalNumber){
				var a=parseInt(personalNumber.substring(0,1),10),
					b=parseInt(personalNumber.substring(1,2),10),
					c=parseInt(personalNumber.substring(2,3),10),
					d=parseInt(personalNumber.substring(3,4),10),
					e=parseInt(personalNumber.substring(4,5),10),
					f=parseInt(personalNumber.substring(5,6),10),
					g=parseInt(personalNumber.substring(6,7),10),
					h=parseInt(personalNumber.substring(7,8),10),
					i=parseInt(personalNumber.substring(8,9),10),
					j=parseInt(personalNumber.substring(9,10),10);

				var sum = a * 1 + b * 3 + c * 7 + d * 9 + e * 1 + f * 3 + g * 7 + h * 9 + i * 1 + j * 3;
				var calculatedChecksum = sum % 10;
				return (10 - calculatedChecksum) % 10;
			}

			function belongsInArray(elem, array) {
				for (var x = 0; x <= array.length; x++) {
					if (array[x] == elem)
						return true;
				}
				return false;
			}

			if (personalNumber.length != 11) {
				return false;
			}

			if (personalNumber % 1 !== 0) {
				return false;
			}

			var year = parseInt(personalNumber.substring(0, 2));
			var monthraw = parseInt(personalNumber.substring(2, 4));
			var month = monthraw % 20;
			var bigMonth=[1,3,5,7,8,10,12];
			var smallMonth=[4,6,9,11];
			var faburary=[2];
			var day = personalNumber.substring(4, 6);

			if(belongsInArray(month,bigMonth)){
				if (parseInt(day, 10) > 31 || parseInt(day, 10) < 1) {
					return false;
				}
			}else if(belongsInArray(month,smallMonth)){
				if (parseInt(day, 10) > 30 || parseInt(day, 10) < 1) {
					return false;
				}
			}else if(belongsInArray(month,faburary)){
				if (year % 100 == 0 && monthraw == 22) {
					if (parseInt(day, 10) > 29 || parseInt(day, 10) < 1) {
						return false;
					}
				}else if (year % 100 != 0 && year % 4 == 0){
					if (parseInt(day, 10) > 29 || parseInt(day, 10) < 1) {
						return false;
					}
				} else{
					if (parseInt(day, 10) > 28 || parseInt(day, 10) < 1) {
						return false;
					}
				}
			}else{
				return false;
			}

			var sumCheck = personalNumber.substring(10);
			var calculatedChecksum=calculateCheckNumber(personalNumber)
			if(calculatedChecksum!==parseInt(sumCheck)){
				return false;
			}
			return true;
		}

		var value = $autoFillInput.val(),
			isNumeric = $.isNumeric(value);
		if (value !== '' && (isNrDashNrSSIDFormat(value) || isNumeric)) {
			if (value.length === calculateLengthOfPersonalNumber(isNumeric) && !wrongPersonalNumber && (siteId !== 8 || siteId === 8 && checkPesel(value))) {
				$autoFillInput.parent().addClass(VALID_CLASS).removeClass(ERROR_CLASS);
				signUpValidation.showGreenTick($autoFillInput);
			} else {
				$autoFillInput.parent().addClass(ERROR_CLASS).removeClass(VALID_CLASS);
				if (event.type === 'keyup') {
					$autoFillInput.parent().removeData(DYNAMIC_ERROR_MESSAGE_DATA_ATTRIBUTE);
				}
				signUpValidation.hideGreenTick($autoFillInput);
			}
		} else if (isAutoFillDirty()) {
			$autoFillInput.parent().addClass(ERROR_CLASS).removeClass(VALID_CLASS);
			$autoFillInput.parent().removeData(DYNAMIC_ERROR_MESSAGE_DATA_ATTRIBUTE);
			signUpValidation.hideGreenTick($autoFillInput);
		}
	}


	function isNrDashNrSSIDFormat(value) {
		//checks if the SSID is number dash number format
		return /^[0-9]+-[0-9]+$/.test(value);
	}

	function validateAutoFillOnEvents() {
		$autoFillInput.focusout(function (event) {
			validateAutoFill(event);
		});
	}

	function isIntegerNumber(value) {
		return /^\d+$/.test(value);
	}

	function cleanAutoFillForm(signUpDetail) {
		signUpDetail.$box.find('.account-details').nextUntil('#phone-row').find('input').each(function () {
			if ($(this).attr('name') !== 'PARAM_CALLING_CODE' && $(this).attr('name') !== 'PARAM_GENDER_MALE' && $(this).attr('name') !== 'PARAM_GENDER_FEMALE') {
				$(this).val('');
				$(this).parent().removeClass(HAS_AUTOFILL_CLASS);
			}
		});
		signUpDetail.$box.find('#birth-date-id').find('select').each(function () {
			$(this).find('option:first').attr('selected', 'selected');
			$(this).parent().removeClass(HAS_AUTOFILL_CLASS);
		});
	}

	function phoneNumberHandler(signUpDetail, event) {
		var $phoneInputElement = $(this),
			$phoneParent = $phoneInputElement.parent(),
			contentPhoneInput = $phoneInputElement.val();

		isValidPhoneChecked = true;
		event.stopPropagation();

		if (isPhoneNumberDirty($phoneParent)) {
			if (contentPhoneInput === '' || !isIntegerNumber(contentPhoneInput)) {
				boxLoading.removeLoading(signUpDetail.$box);
				$phoneParent.removeData(DYNAMIC_ERROR_MESSAGE_DATA_ATTRIBUTE);
				$phoneParent.addClass(ERROR_CLASS).removeClass(VALID_CLASS);
			} else {
				checkUniqueMobileNumber($phoneInputElement);
			}
		} else {
			$phoneInputElement.val($phoneInputElement.data('holder'));
		}
		$phoneParent.find('.popover').hide();
	}

	function setUpHandlerPhoneNumber(signUpDetail) {
		var $phoneInputElement = signUpDetail.$box.find('input[name=PARAM_PH_NUMBER]');

		$phoneInputElement.focusout(function (event) {
			phoneNumberHandler.call(this, signUpDetail, event);
		});
	}

	function handlePhoneNumberValue(signUpDetail) {
		var $phone = signUpDetail.$box.find('input[name=PARAM_PH_NUMBER]'),
			$phoneParent = $phone.parent();

		$phone.focusin(function () {
			if (!isPhoneNumberDirty($phoneParent)) {
				$(this).val('');
			}
		});
	}

	function isPhoneNumberDirty($phoneParent) {
		return $phoneParent.hasClass('is-dirty');
	}

	function checkUniqueMobileNumber($phone) {
		var $parentPhone = $phone.parent(),
			$callingCode = $parentPhone.prev().find('input'),
			dataToBeSent = {
				PARAM_PHONE_NUMBER: $phone.val(),
				PARAM_CALLING_CODE: $callingCode.val()
			},
			jqxhr = $.ajax({
				url: '/pp?flow=CheckMobile',
				data: dataToBeSent
			});
		jqxhr
			.done(function (data) {
				isValidPhone = data.RESULT === 'OK';
				if (isValidPhone ) {
					$parentPhone.removeClass(ERROR_CLASS).addClass(VALID_CLASS);
				} else {
					$parentPhone.data(DYNAMIC_ERROR_MESSAGE_DATA_ATTRIBUTE, data.ERROR);
					$parentPhone.removeClass(VALID_CLASS).addClass(ERROR_CLASS);
					// toolTip.showError($parentPhone);
				}
			})
			.always(function () {
				hideLoadingGif($parentPhone);
				// let's the tooltip remains if the phone number is not valid and user clicks on the submit button
				if (!isValidPhone) {
					toolTip.showError($parentPhone);
				}
			});
		showLoadingGif($parentPhone);

	}

	function checkUniqueMobileNumberSubmit($phone, signUpDetail) {
		var $parentPhone = $phone.parent(),
			$callingCode = $parentPhone.prev().find('input'),
			dataToBeSent = {
				PARAM_PHONE_NUMBER: $phone.val(),
				PARAM_CALLING_CODE: $callingCode.val()
			},
			jqxhr = $.ajax({
				url: '/pp?flow=CheckMobile',
				data: dataToBeSent
			});
		jqxhr
			.done(function (data) {
				isValidPhone = data.RESULT === 'OK';
				if (isValidPhone && isSubmitClicked) {
					$('.game').remove(); // TODO: ugly fix for BANJO-908
					setupOpenAccount(signUpDetail);
					$parentPhone.removeClass(ERROR_CLASS).addClass(VALID_CLASS);
				} else if (!isValidPhone && isSubmitClicked) {
					$parentPhone.data(DYNAMIC_ERROR_MESSAGE_DATA_ATTRIBUTE, data.ERROR);
					boxLoading.removeLoading(signUpDetail.$box);
					$parentPhone.removeClass(VALID_CLASS).addClass(ERROR_CLASS);
					// toolTip.showError($parentPhone);
				} else if (!isValidPhone && !isSubmitClicked) {
					$parentPhone.data(DYNAMIC_ERROR_MESSAGE_DATA_ATTRIBUTE, data.ERROR);
					$parentPhone.removeClass(VALID_CLASS).addClass(ERROR_CLASS);
					// toolTip.showError($parentPhone);
				} else if (!isSubmitClicked && isValidPhone) {
					$parentPhone.removeClass(ERROR_CLASS).addClass(VALID_CLASS);
				}
			})
			.always(function () {
				hideLoadingGif($parentPhone);
				// let's the tooltip remains if the phone number is not valid and user clicks on the submit button
				if (!isValidPhone) {
					toolTip.showError($parentPhone);
				}
			});
		showLoadingGif($parentPhone);

	}

	function handleEmptyPhoneNumbers(signUpDetail) {
		addClassOnKeyPress(signUpDetail.$box.find('input[name=PARAM_PH_NUMBER]'));
	}

	function handleEmptyAutoFill() {
		addClassOnKeyPress($autoFillInput);
	}

	function addClassOnKeyPress($element) {
		$element.keypress(function (event) {
			if (event.which !== 0) {
				$element.parent().addClass('is-dirty');
			}
		});
	}

	function setSubmitClicked(signUpDetail) {
		signUpDetail.$box.find('#open-account-button').click(function (event) {
			event.preventDefault();
			event.stopPropagation();
			isSubmitClicked = true;
			boxLoading.showLoading(signUpDetail.$box);
			checkUniqueMobileNumberSubmit(signUpDetail.$box.find('input[name=PARAM_PH_NUMBER]'), signUpDetail);
		});
	}

	function setupOpenAccount(signUpDetail) {
		var $signUpForm = signUpDetail.$box.find('form');
		signUpValidation.validateDateTheFirstTime();
		signUpValidation.validateDanishGamblingRange();
		validateEmptyPhone(signUpDetail);
		submit(signUpDetail);
	}

	function submit(signUpDetail) {
		var $signUpForm = signUpDetail.$box.find('form');
		if (signUpValidation.isFormValidated($signUpForm)) {
			var fv = swfobject.getFlashPlayerVersion();
			var flashVersion = fv.major + '.' + fv.minor + ' r' + fv.release;
			signUpDetail.$box.find('#PARAM_FLASH_VERSION').val(flashVersion);
			$signUpForm.find('#did').val(security.getDeviceId());
			enablingCountryCC(signUpDetail);
			FSJSC_profile(signUpDetail, setDeviceIdCallback);
			signUpValidation.fillCPRFormattedCode($signUpForm);
		} else {
			boxLoading.removeLoading(signUpDetail.$box);
			isSubmitClicked = false;
		}
	}

	function setDeviceIdCallback(signUpDetail, fingerprint) {
		var $signUpForm = signUpDetail.$box.find('form');

		$($signUpForm).find('#deviceIdHashCode').val(generateHashCode(fingerprint));

		$.post('/pp?flow=SignUpOpenAccount', $signUpForm.serialize()).done(function (data) {

			if (signUpDetail.model.disableCountryCallingCode) {
				disablingCountryCC(signUpDetail);
			}

			boxLoading.removeLoading(signUpDetail.$box);
			if (data.RESULT === 'OK') {

				signUpDetail.$controller.trigger('SHOW_MESSAGE_SUCCESS');
				signUpDetail.$controller.trigger(signUpEvent.REGISTER_SUCCESS);
				signUpDetail.$controller.trigger(landingEvent.ACCOUNT_CREATED);

				var $slidingContentWrapperDiv = signUpDetail.$controller.$controller.closest('div').parent();
				$slidingContentWrapperDiv.find('.middle.bar.signup').hide();

				signUpDetail.$controller.nextBox();
				signUpDetail.$controller.trigger('SLIDE_ICON');
				hideLicenceAboutUs();
				signupLogin.execute(data);
			} else {
				messagePopup.show(signUpDetail.$box, 'message-popup', {
					title: 'ERROR',
					message: data.ERROR,
					closeButtonText: data.BUTTON_TEXT
				});
			}
		});
	}

	function generateHashCode(strObject) {
        var strArray = Object.keys(strObject).map(function(e) {
            return strObject[e]
        })
		var strConcat = strArray.join();
		var hash = 0,
			i,
			chr;
		if (strConcat.length === 0) return hash;
		for (i = 0; i < strConcat.length; i++) {
			chr = strConcat.charCodeAt(i);
			hash = (hash << 5) - hash + chr;
			hash |= 0; // Convert to 32bit integer
		}
		return hash;
	}

	function validateEmptyPhone(signUpDetail) {
		var $phone = signUpDetail.$box.find('input[name=PARAM_PH_NUMBER]');
		if (isNaN($phone.val()) || $phone.val() === '') {
			highLightPhoneAndShowErrorTooltip($phone);
		}
	}

	function highLightPhoneAndShowErrorTooltip($phone) {
		$phone.parent().addClass(ERROR_CLASS).removeClass(VALID_CLASS);
		toolTip.showError($phone.parent());
	}

	function listenForEnter(signUpDetail) {
		signUpDetail.$box.find('#signup-autofill').keypress(function () {
			if (event.which === ENTER_EVENT) {
				signUpDetail.$box.find('#person-lookup-button').click();
			}
		});
	}

	function listenForGenderClick(signUpDetail) {
		function removeErrorFromButton($genderElement) {
			$genderElement.find('.btn').removeClass('has-error');
		}

		var $genderElement = signUpDetail.$box.find('.gender');
		$genderElement.find('div:nth-child(2)').click(function () {
			autoClickFemale($genderElement);
			removeErrorFromButton($genderElement);
		});
		$genderElement.find('div:nth-child(1)').click(function () {
			autoClickMale($genderElement);
			removeErrorFromButton($genderElement);
		});
	}

	function disablingCountryCC(signUpDetail) {
		signUpDetail.$box.find('#countries-holder').attr('disabled', 'disabled');
		signUpDetail.$box.find('#calling-code-holder').find('input').attr('disabled', 'disabled');
	}

	function enablingCountryCC(signUpDetail) {
		signUpDetail.$box.find('#countries-holder').removeAttr('disabled');
		signUpDetail.$box.find('#calling-code-holder').find('input').removeAttr('disabled');
	}

	function hideLoadingGif($parentInput) {
		$parentInput.find('img').hide();
	}

	function showLoadingGif($parentInput) {
		$parentInput.find('img').show();
	}

	function resetIsSubmittedClicked(signUpDetail) {
		signUpDetail.$box.find('input[name=PARAM_PH_NUMBER]').focusin(function () {
			isSubmitClicked = false;
		});
	}


	function hideLicenceAboutUs() {
		var $MGAlogo = $('.cnt-overlay.signup .bottom-menu .right .logos');
		if ($MGAlogo.length === 0) {
			$MGAlogo = $('#start-bottom-menu').find('.logos');
		}
		$MGAlogo.hide();
		$MGAlogo.next().hide();
	}

	function resetFormFields($box) {
		var $phone = $box.find('input[name=PARAM_PH_NUMBER]');
		$phone.parent().removeClass('is-dirty');
		$box.find('input').each(function () {
			$(this).val('');
			if ($(this).attr('name') === 'PARAM_PH_NUMBER') {
				$(this).val($phone.data('holder'));
			}
			$(this).parent().addClass(VALID_CLASS).removeClass(ERROR_CLASS);
		});
		$box.find('select').each(function () {
			$(this).find('option:first').attr('selected', 'selected');
			$(this).parent().addClass(VALID_CLASS).removeClass(ERROR_CLASS);
		});
		$box.find('input[name=PARAM_GENDER_MALE]').val('male');
		$box.find('span.s20-check').hide();
		$box.find('div').removeClass('has-autofill');

		$box.find('.box').hide();
		$box.find('.popover').hide();
		$box.find('.summary').show();
		$box.find('.edit').hide();
	}

	function bindCountryCurrencyCallingCode(signUpDetail) {

		var htmlMethod = {method: 'html'},
			$currencyHolder = signUpDetail.$box.find('#currencies-holder'),
			$countryHolder = signUpDetail.$box.find('#countries-holder'),
			$statesHolder = signUpDetail.$box.find('#states-holder'),
			$callingCodeHolder = signUpDetail.$box.find('#calling-code-holder'),
			$gamblingRangeHolder = signUpDetail.$box.find('#gamblingRangeSelect');

		$.Mustache.addFromDom('currencies-template');
		$currencyHolder.mustache('currencies-template', {currencies: signUpDetail.model.currencies}, htmlMethod);

		$.Mustache.addFromDom('countries-template');
		$countryHolder.mustache('countries-template', {countries: signUpDetail.model.countries}, htmlMethod);

		$.Mustache.addFromDom('gambling-range-template');
		$gamblingRangeHolder.mustache('gambling-range-template', {danishGamblingRange: signUpDetail.model.danishGamblingRange}, htmlMethod);

		if (countryIsoCode === 'ca') {
			$statesHolder.parent().show();
			$countryHolder.parent().removeClass('col-9').addClass('col-6');
			$.Mustache.addFromDom('states-template');
			$statesHolder.mustache('states-template', {states: signUpDetail.model.states}, htmlMethod);
		}

		$.Mustache.addFromDom('calling-code-template');
		$callingCodeHolder.mustache('calling-code-template', {callingCode: signUpDetail.model.callingCode}, htmlMethod);

		if (signUpDetail.model.disableCountryCallingCode) {
			disablingCountryCC(signUpDetail);
		}
	}

	function init(signUpDetail) {

		signUpDetail.$controller.on('ACCOUNT_DATA', function (event, data) {
			resetFormFields(signUpDetail.$box);
			fillUsernameEmailFromFirstStep(signUpDetail, data);
		});
		$autoFillInput = signUpDetail.$box.parent().find('#signup-autofill');
		countryIsoCode = signUpDetail.$box.find('input[name=personalnumber]').data('country-iso-code').toLowerCase();
		siteId=signUpDetail.$box.find('input[name=personalnumber]').data('site-id');
		if (countryIsoCode === '' || countryIsoCode === '**') {
			countryIsoCode = 'se';
		}
		setupEditSummaryClickLogic(signUpDetail);
		setupAutoFillClickLogic(signUpDetail);
		validateAutoFillOnEvents();
		setSubmitClicked(signUpDetail);
		listenForEnter(signUpDetail);
		listenForGenderClick(signUpDetail);
		setUpHandlerPhoneNumber(signUpDetail);
		handlePhoneNumberValue(signUpDetail);
		handleEmptyPhoneNumbers(signUpDetail);
		handleEmptyAutoFill();
		resetIsSubmittedClicked(signUpDetail);
		addressFinder.init(signUpDetail);
	}

	function isPersonalLookupEnabled() {
		if(siteId===8){
			return true;
		}
		var countryCodes = configuration.personLookupCountryCodes.split(','),
			sessionCountryCode = configuration.sessionCountryCode;

		return $.inArray(sessionCountryCode, countryCodes) > -1;
	}

	var view = {
			render: function (signUpDetail) {
				bindCountryCurrencyCallingCode(signUpDetail);
			}
		},
		model = {
			currencies: [],
			countries: [],
			states: [],
			callingCode: '',
			init: init,
			beforeRender: function beforeRender(signUpDetail) {
				var ajaxAutoFillPromise = getAjaxAutoFillPromise(signUpDetail);
				var ajaxDetailDataPromise = getAjaxDetailDataPromise(signUpDetail);
				addressFinder.hideAddressResultsOnFocusOut(signUpDetail);
				return [ajaxAutoFillPromise, ajaxDetailDataPromise];
			},
			afterRender: function afterRender(signUpDetail) {
				middleBarHelper.show(signUpDetail, 'signup');
				addressFinder.showCorrectAddressLayout(signUpDetail);
				signupRenderHelper.setupTermsAndConditions(signUpDetail);
			},
			close: function (signUpDetail) {
				middleBarHelper.hide(signUpDetail, 'signup');
			}
		};

	return {
		create: function ($box, $controller) {
			return box.create($box, $controller, view, model);
		}
	};
});

